import ReactDOM from 'react-dom/client';
import './index.css';
import { App } from './App';

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

const root = ReactDOM.createRoot(rootElement as HTMLElement);
root.render(<App />);